import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable, Subject } from 'rxjs';
import { Constants } from '../constants';
import { UsersService } from './users.service';
import { FGAData } from '../fga/models';

@Injectable({
  providedIn: 'root'
})
export class AetStateService {
  private guidStateSource = new BehaviorSubject<string>('');// NOSONAR
  guidState = this.guidStateSource.asObservable();
  private roleStateSource = new BehaviorSubject<string>(''); // NOSONAR
  roleState = this.roleStateSource.asObservable();
  private userInfoSource = new BehaviorSubject<string>('');// NOSONAR
  userInfoState = this.userInfoSource.asObservable();
  private rolesStateSource = new BehaviorSubject<string>('');// NOSONAR
  rolesState = this.roleStateSource.asObservable();
  public details$ = new BehaviorSubject<FGAData>(null);
  constructor(private readonly userService: UsersService, private  readonly constants: Constants) { }

  getGUIDState() {
    return this.guidStateSource.getValue();
  }

  setGUIDState(name: string) {
    this.guidStateSource.next(name);
  }

  getroleState() {
    return this.roleStateSource.getValue();
  }
  setroleState(role: string) {
    this.roleStateSource.next(role);
  }

  getRealroleState() {
    return this.rolesStateSource.getValue();
  }
  setRealroleState(role: string) {
    this.rolesStateSource.next(role);
  }

  getuserInfoState() {
    return this.userInfoSource.getValue();
  }

  setuserInfoState(value: string) {
    localStorage.setItem('loggedInUser', JSON.parse(value).strusername);
    this.userInfoSource.next(value);
  }

  async getRoles() {
    const areRolesPresent = this.getroleState();
    if (!areRolesPresent) {
      if (!this.getGUIDState())
        {await new Promise(f => setTimeout(f, 2000));}
      await this.getUserInfo(localStorage.getItem('toyotaGUID')).then((x) => {
        if (!x) {
          console.info("Aet State Service Role Error");
          window.location.replace(this.constants.LIOSMainPortalURL);
        }
      })
    }
  }

  async getUserInfo(toyotaGUID): Promise<boolean> {
    let isValidRole = false;
    await this.userService.getUserInfoFreeze(toyotaGUID).then(
      (result) => {
        if (result && result.length > 0) {
          const userInfo = result;
          const rolesArray = [];
          const originalrolesArray = [];
          userInfo.forEach(e => {
            const roleName = e.strrole //+ String(e.logisticspoint ? "/" + e.logisticspoint : "")
            const orgRolesArray = e.strrole + String(e.logisticspoint ? "/" + e.logisticspoint : "")
            if (!rolesArray.includes(roleName))
              {rolesArray.push(roleName)}
            if (!originalrolesArray.includes(orgRolesArray))
              {originalrolesArray.push(orgRolesArray)}
          });
          if (rolesArray && (rolesArray.includes(this.constants.LIOS_UAC_Admin) || rolesArray.includes(this.constants.LIOS_UAC_LP_Filter) ||
            rolesArray.includes(this.constants.LIOS_UAC_AET_Admin) ||
            rolesArray.includes(this.constants.LIOS_UAC_TEMA_Ops) || rolesArray.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
            rolesArray.includes(this.constants.LIOS_UAC_AET_LP) || rolesArray.includes(this.constants.LIOS_UAC_MTMUS_Planner)
            || rolesArray.includes(this.constants.LIOS_UAC_MTMUS_Negotiator) || rolesArray.includes(this.constants.LIOS_UAC_Portal_Administrator)
            || rolesArray.includes(this.constants.LIOS_UAC_Reporting_Admin) || rolesArray.includes(this.constants.LIOS_UAC_Reporting_User)
            || rolesArray.includes(this.constants.LIOS_UAC_Route_Planner) || rolesArray.includes(this.constants.LIOS_UAC_SCV_Admin)
            || rolesArray.includes(this.constants.LIOS_UAC_Security_Admin) || rolesArray.includes(this.constants.LIOS_UAC_TEMA_AF)
            || rolesArray.includes(this.constants.LIOS_UAC_TEMA_Budgeting) || rolesArray.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
            || rolesArray.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist) || rolesArray.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
            || rolesArray.includes(this.constants.LIOS_UAC_TEMA_LC) || rolesArray.includes(this.constants.LIOS_UAC_TPT_Admin)
            || rolesArray.includes(this.constants.LIOS_UAC_TSCS_Admin) || rolesArray.includes(this.constants.LIOS_UAC_WT_Administrator))) {
            isValidRole = true;
          }
          this.setRealroleState(JSON.stringify(originalrolesArray));
          this.setroleState(JSON.stringify(rolesArray));
          this.setuserInfoState(JSON.stringify(userInfo[0]));
        }
      }, error => {
        console.info(error)
      });
    return isValidRole;
  }

  getDetails(): Observable<FGAData> {
    return this.details$.asObservable();
  }
}

